export default "__VITE_ASSET__4b13c5p3__"